import { createGlobalStyle } from 'styled-components';

/* bootstrap-like classes */
const GlobalStyle = createGlobalStyle`
  .p-6 {
    padding: 6rem !important;
  }

  .pe-6 {
    padding-right: 6rem !important;
  }
  @keyframes blink {
    0%, 50%, 100% { opacity: 1; }
    25%, 75% { opacity: 0; }
  }

  .team-summary-team{
  }
  @media (min-width: 768px) {
    .team-summary-team { width: 50%; }
  }
`;

export default GlobalStyle;
